// extracted by mini-css-extract-plugin
export default {"layer":"TimelineHeader_layer__zXVhU","grid":"TimelineHeader_grid__d0n0v","timeline":"TimelineHeader_timeline__ZQO8j"};